import { type FlexStyle, View, Text, ScrollView, Platform } from 'react-native'
import { RewardsComponentsActionButton } from '@/src/experiences/rewards/components/RewardsComponentsActionButton'
import type { ComponentProps } from 'react'
import { useRewardsActions } from '@/src/experiences/rewards/hooks/useRewardsActions'
import { mesaColorNames, typography } from '@/src/common/theme'
import { useMainWrapperPadding } from '@/src/common/wrappers/MainWrapper'

type Props = Pick<FlexStyle, 'gap'> & Pick<ComponentProps<typeof View>, 'style'>

export function RewardsComponentsActions({ gap, style }: Props) {
  const actions = useRewardsActions()

  const padding = useMainWrapperPadding()

  return (
    <View style={[{ gap: 16, flexDirection: 'column', alignItems: 'stretch' }, style]}>
      {actions.map(([title, actions]) => (
        <View key={title}>
          <View
            style={{
              backgroundColor: mesaColorNames['Mesa Primary Scale/400 - Brand #00DFC9'],
              height: 4,
              maxHeight: 'none',
              width: 48,
            }}
          />
          <Text
            style={[
              typography['heading/heading3'],
              { color: mesaColorNames['Mesa - Brand/Secondary #223843'], marginTop: 4 },
            ]}
          >
            {title}
          </Text>
          <ScrollView
            horizontal
            style={{
              width: 'auto',
              paddingVertical: 16,
              paddingHorizontal: padding,
              marginHorizontal: -padding,
              marginTop: 0,
            }}
            contentContainerStyle={[
              { gap },
              Platform.OS !== 'web' && { paddingRight: padding * 2 },
            ]}
            showsHorizontalScrollIndicator={false}
            {...(Platform.OS === 'ios'
              ? {
                  snapToInterval: actionButtonWidth + 16,
                  snapToAlignment: 'center',
                  decelerationRate: 'fast',
                }
              : undefined)}
          >
            {actions.map((action) => (
              <RewardsComponentsActionButton
                key={action.label}
                style={{ width: actionButtonWidth }}
                rewardsAction={action}
              />
            ))}
          </ScrollView>
        </View>
      ))}
    </View>
  )
}

/** @see {@link https://www.figma.com/design/qaGLT95sJewnl3S2o7Xvus/Brand?node-id=27988-11707&t=a5ZrLwxM9cXin0P5-4} */
const actionButtonWidth = 109
